import { isEmpty } from 'lodash';

export function parseQueryParams(string: string) {
  if (isEmpty(string)) {
    return {};
  }

  const keyValuePairs = string.split('&');

  return keyValuePairs.reduce<any>((result, keyValuePair) => {
    if (isEmpty(keyValuePair)) {
      return result;
    }

    const [key, value] = keyValuePair.split('=');

    return {
      ...result,
      [key]: value,
    };
  }, {});
}
